import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { Item, ShopCategory, ShopSubCategory } from '../../models/items.model';
import { FormsModule } from '@angular/forms';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-item-selector',
  imports: [MatFormFieldModule, MatSelectModule, MatOptionModule, MatIconModule, MatButtonModule, FormsModule, NgxMatSelectSearchModule, MatTooltipModule],
  templateUrl: './item-selector.component.html',
  styleUrls: ['./item-selector.component.scss'],
})
export class ItemSelectorComponent {
  @Input() shopCategories: ShopCategory[] = [];
  filteredShopCategories: ShopCategory[] = [];
  filteredShopSubCategories: ShopSubCategory[] = [];
  @Input() items: Item[] = [];
  filteredItems: Item[] = [];
  @Input() showItemSelector: boolean = true;

  @Output() selectedCategoryChange = new EventEmitter<ShopCategory | null>();

  @Output() selectedSubCategoryChange = new EventEmitter<ShopSubCategory | null>();

  @Output() selectedTierChange = new EventEmitter<number | null>();

  @Output() selectedItemChange = new EventEmitter<Item | null>();

  private _selectedCategory!: ShopCategory | null;
  private _selectedSubCategory!: ShopSubCategory | null;
  private _selectedTier!: number | null;
  private _selectedItem!: Item | null;

  @Input()
  set selectedCategory(value: ShopCategory | null) {
    this.selectedCategoryChange.emit(value);
    this._selectedCategory = value;
    if (this.selectedCategory) {
      this.filteredShopSubCategories = this.selectedCategory.subCategories;
    } else {
      this.selectedSubCategory = null;
    }
    this.filterItems('');
  }
  @Input()
  set selectedSubCategory(value: ShopSubCategory | null) {
    this.selectedSubCategoryChange.emit(value);
    this._selectedSubCategory = value;
    this.filterItems('');
  }
  @Input()
  set selectedTier(value: number | null) {
    this.selectedTierChange.emit(value);
    this._selectedTier = value;
    this.filterItems('');
  }
  @Input()
  set selectedItem(value: Item | null) {
    this.selectedItemChange.emit(value);
    this._selectedItem = value;
    if (!this.selectedItem) this.filterItems('');
  }

  get selectedCategory(): ShopCategory | null {
    return this._selectedCategory;
  }
  get selectedSubCategory(): ShopSubCategory | null {
    return this._selectedSubCategory;
  }
  get selectedTier(): number | null {
    return this._selectedTier;
  }
  get selectedItem(): Item | null {
    return this._selectedItem;
  }

  tiers: number[] = [1, 2, 3, 4, 5, 6, 7, 8];

  itemSelectAmountOptions: number = 100;

  constructor() {
    this.filterItems('');
  }

  ngOnInit() {
    this.filteredShopCategories = this.shopCategories;
  }

  clearAll(): void {
    this.selectedCategory = null;
    this.selectedTier = null;
    this.selectedItem = null;
  }

  filterShopCategories(value: string) {
    if (!value) {
      // If there is no search value, reset the filtered options to show all options
      this.filteredShopCategories = this.shopCategories;
    } else {
      // If there is a search value, filter the options array
      this.filteredShopCategories = this.shopCategories.filter((category) => category.displayName.toLowerCase().includes(value.toLowerCase()));
    }
  }
  filterShopSubCategories(value: string) {
    if (!value) {
      // If there is no search value, reset the filtered options to show all options
      this.filteredShopSubCategories = this.selectedCategory?.subCategories ?? [];
    } else {
      // If there is a search value, filter the options array
      this.filteredShopSubCategories = (this.selectedCategory?.subCategories ?? []).filter((subCategory) =>
        subCategory.displayName.toLowerCase().includes(value.toLowerCase())
      );
    }
  }

  filterItems(value: string): void {
    if (this.items) {
      this.filteredItems = this.items.filter((x) => x.localizedName.length > 1);
      if (this.selectedCategory) {
        if (this.selectedSubCategory) {
          this.filteredItems = this.filteredItems.filter(
            (item) => item.shopCategory === this.selectedCategory?.name && item.shopSubCategory === this.selectedSubCategory?.name
          );
        } else {
          this.filteredItems = this.filteredItems.filter((item) => item.shopCategory === this.selectedCategory?.name);
        }
      }
      if (this.selectedTier) {
        this.filteredItems = this.filteredItems.filter((item) => item.tier === this.selectedTier);
      }
      if (value) {
        this.filteredItems = this.filteredItems.filter((item) => item.localizedName.toLowerCase().includes(value.toLowerCase()));
      }
      if (this.selectedItem && !this.filteredItems.slice(0, this.itemSelectAmountOptions).includes(this.selectedItem))
        this.filteredItems.unshift(this.selectedItem);
    } else {
      this.filteredItems = [];
    }
  }
}
